let initialState = null;

function insign(state = initialState, action) {
  if (action.type === "INITIALIZE_INSIGN") {
    return action.res;
  } else if (action.type === "MAIL_SEND_INSIGN") {
    return action.res;
  } else if (action.type === "RESET_INSIGN") {
    return action.res;
  } else {
    return state;
  }
}

export default insign;
